var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SearchStatus } from '@/overmind/search/state';
import SearchNotFoundHeader from 'modules/search/components/SearchNotFoundHeader.vue';
import { json } from 'overmind';
import { isEmpty } from 'lodash';
let NumberOfEmployees = class NumberOfEmployees extends Vue {
    constructor() {
        super(...arguments);
        this.numberOfCompanyEmployeesNotSelected = [];
        this.graphicsType = true;
        this.mappedNumberOfEmployees = [];
        this.colorPalette = [
            '#14AAFF',
            '#C1CB33',
            '#FDD836',
            '#A970EB',
            '#F47C67',
        ];
        this.chartOptions = {
            chart: {
                type: 'treemap',
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        color: 'black',
                        style: {
                            textOutline: '0px',
                            fontWeight: 'none',
                        },
                    },
                },
            },
            series: [
                {
                    type: 'treemap',
                    layoutStartingDirection: 'horizontal',
                    title: {
                        text: '',
                    },
                    data: [],
                },
            ],
            title: {
                text: '',
            },
            credits: false,
        };
    }
    async handleNumberOfEmployees(values) {
        const totalValue = await this.getTotalValue();
        const percentageValue = await this.calculatePercentage(totalValue);
        let mappedNumberOfEmployees = values
            .filter(item => item.doc_count > parseInt(percentageValue.toFixed()))
            .map(value => {
            return {
                name: value.key,
                value: value.doc_count,
                color: '',
            };
        });
        return this.addColors(mappedNumberOfEmployees);
    }
    addColors(mappedNumberOfEmployees) {
        this.colorPalette.forEach((color, indexColor) => {
            mappedNumberOfEmployees.forEach((item, index) => {
                if (index === indexColor)
                    item['color'] = color;
            });
        });
        return mappedNumberOfEmployees;
    }
    calculatePercentage(totalValue) {
        return totalValue * (parseFloat('1.1') / 100);
    }
    getTotalValue() {
        let count = 0;
        if (!isEmpty(this.numberOfEmployees)) {
            json(this.numberOfEmployees).forEach((item) => {
                count += item.doc_count;
            });
        }
        return count;
    }
    async onNumberOfCompanyEmployeesChanged() {
        this.chartOptions.series[0].data = await this.handleNumberOfEmployees(this.numberOfCompanyEmployees);
    }
    async onNumberOfCompanyEmployeesNotChanged(val) {
        const numberOfCompanyEmployees = json(val);
        const numEmployees = numberOfCompanyEmployees.filter(el => {
            return !this.chartOptions.series[0].data
                .map(num => num.key)
                .includes(el.key);
        });
        this.numberOfCompanyEmployeesNotSelected = numEmployees;
    }
    onCreateSearchStateChanged() {
        if (!this.graphicsType)
            this.graphicsType = true;
    }
    async changeGraphicsType() {
        this.graphicsType = !this.graphicsType;
        if (this.graphicsType) {
            this.chartOptions.series[0].data = await this.handleNumberOfEmployees(this.numberOfCompanyEmployees);
        }
        else {
            this.chartOptions.series[0].data = await this.handleNumberOfEmployees(this.numberOfEmployees);
        }
    }
    async mounted() {
        this.graphicsType = true;
        this.chartOptions.series[0].data = await this.handleNumberOfEmployees(this.numberOfCompanyEmployees);
    }
};
__decorate([
    Prop({ default: () => [] })
], NumberOfEmployees.prototype, "numberOfEmployees", void 0);
__decorate([
    Prop({ default: SearchStatus.NOT_RECEIVED })
], NumberOfEmployees.prototype, "createSearchState", void 0);
__decorate([
    Prop({ default: () => [] })
], NumberOfEmployees.prototype, "numberOfCompanyEmployees", void 0);
__decorate([
    Prop({ default: 1 })
], NumberOfEmployees.prototype, "page", void 0);
__decorate([
    Watch('numberOfCompanyEmployees')
], NumberOfEmployees.prototype, "onNumberOfCompanyEmployeesChanged", null);
__decorate([
    Watch('numberOfCompanyEmployees')
], NumberOfEmployees.prototype, "onNumberOfCompanyEmployeesNotChanged", null);
__decorate([
    Watch('createSearchState')
], NumberOfEmployees.prototype, "onCreateSearchStateChanged", null);
NumberOfEmployees = __decorate([
    Component({
        components: {
            SearchNotFoundHeader,
        },
    })
], NumberOfEmployees);
export default NumberOfEmployees;
